import { GraphComponent, IBend, IEdge, ILabel, INode } from "yfiles";
export default (graphComponentRef, onlySelection = false) => {
    var _a, _b;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return null;
    const component = new GraphComponent();
    if (onlySelection) {
        const selectedNodes = (_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.selection.selectedNodes;
        component.clipboard.ignoreEdgesWithOneNode = true;
        component.clipboard.copy(graphComponentRef.current.graph, (obj) => {
            if (obj instanceof INode)
                return selectedNodes.includes(obj);
            if (obj instanceof ILabel && obj.owner instanceof INode)
                return selectedNodes.includes(obj.owner);
            if (obj instanceof IEdge)
                return Boolean(obj.sourceNode &&
                    obj.targetNode &&
                    selectedNodes.includes(obj.sourceNode) &&
                    selectedNodes.includes(obj.targetNode));
            if (obj instanceof IBend && obj.owner)
                return Boolean(obj.owner.sourceNode &&
                    obj.owner.targetNode &&
                    selectedNodes.includes(obj.owner.sourceNode) &&
                    selectedNodes.includes(obj.owner.targetNode));
            return true;
        });
        component.clipboard.paste(component.graph);
    }
    else {
        component.graph = graphComponentRef.current.graph;
    }
    return component;
};
